export var configParticlesChimneySmoke = {
    acceleration: {
        x: 0,
        y: 0,
    },
    addAtBack: true,
    alpha: {
        end: 0,
        start: 0.45,
    },
    blendMode: "normal",
    color: {
        end: "#ffffff",
        start: "#ffffff",
    },
    emitterLifetime: 5,
    frequency: 0.001,
    lifetime: {
        max: 0.8,
        min: 0.2,
    },
    maxParticles: 8,
    maxSpeed: 10,
    noRotation: false,
    pos: {
        x: 0,
        y: -300,
    },
    rotationSpeed: {
        max: 0,
        min: 0,
    },
    scale: {
        end: 0.3,
        minimumScaleMultiplier: 1,
        start: 0.1,
    },
    spawnType: "point",
    speed: {
        end: 5,
        minimumSpeedMultiplier: 1,
        start: 100,
    },
    startRotation: {
        max: 280,
        min: 260,
    },
};



//////////////////
// WEBPACK FOOTER
// ./src/features/animation/particles/configParticlesChimneySmoke.ts
// module id = 2192
// module chunks = 3